export default "__VITE_ASSET__2XzK7FvD__"